import { PreviewAnomaly } from '@api/twin/AnomalyApi';
import { Stack } from '@stereograph/teia-system-design/components/Stack';
import { MRT_Row } from '@stereograph/teia-system-design/components/Table';
import { EditAnomalyButton } from './EditAnomalyButton';
import { VisualizeSelectionButton } from './VisualizeSelectionButton';

interface ActionsCellProps {
  row: MRT_Row<PreviewAnomaly>;
}

export const ActionsCell = (props: ActionsCellProps) => {
  const { row } = props;

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <EditAnomalyButton previewAnomaly={row.original} />
      <VisualizeSelectionButton previewAnomaly={row.original} />
    </Stack>
  );
};
